import { PropsWithChildren } from "react";

import { MainLayoutContext } from "./MainLayoutContext";
import { useMainLayout } from "./useMainLayout";

export const MainLayoutProvider = ({ children }: PropsWithChildren) => {
  const mainLayout = useMainLayout();

  return (
    <MainLayoutContext.Provider value={mainLayout}>
      {children}
    </MainLayoutContext.Provider>
  );
};
